class VwHastaislemRedpanikDTO {
    islemId: number = null;
    organizasyonId?: number = null;
    muracaatId?: number = null;
    kurumId?: number = null;
    redtarih?: string = null;
    hastaadsoyad?: string = "";
    hastakimlikId?: number = null;
    islemkodu?: string = "";
    islemadi?: string = "";
    kurumAdi?: string = "";
    organizasyonAdi?: string = "";
}
export default VwHastaislemRedpanikDTO;